import React, { useState, useEffect } from 'react';

const HistorialCama = (p) => {
    const cama = p.cama ?? 0;
    const data = p.data ?? [];
    const headers = ["SEMANA INICIO", "SEMANA FIN", "FECHA INICIO", "FECHA FIN", "DIA TRASPLANTE", "DIA CORTE"];

    return (
        <div className='vh-100 dosis w-100 p-2 m-0 overflow blur-xs bg-black2' style={{ position: "fixed", top: 0, left: 0, zIndex: 5 }}>
            <div className='w-100 m-2 text-end '>
                <button className='btn btn-danger mt-2 shadow ps-5 pe-5 round-xxl me-3' onClick={p.close}>Cerrar</button>
            </div>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='bw-500 p-2 round-xxl bg-white text-center h3 mt-2 mb-0'>Historial de cama {cama.cama}</div>
                <div className='w-100 m-0 p-0'></div>
                <div className='bw-300 opacity-70 p-1 round-xxl bg-white text-center text-bold mt-1 mb-0'>{cama.rancho} - Válvula {cama.valvula}</div>
                <div className='w-100'></div>
                <div className='bw-800 p-2 mt-3 round-m overflow bg-white shadow-multi' style={{ maxHeight: "70vh" }}>
                    {data.length > 0 && <table className='table table-sm'>
                        <thead>
                            <tr>
                                {headers.map((header, i) => <th key={i} scope='col' className='text-center nowrap'>{header}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.map((reg, i) => {
                                    return (
                                        <tr key={i + "dd"}>
                                            {headers.map((header, j) => <th className='text-center nowrap' key={i + header + j} scope='row'>{reg[header]}</th>)}
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>}
                    {data.length === 0 && <div className='w-100 text-center text-danger'>OBTENIENDO LOS DATOS <div className='loader-local'></div> </div>}
                </div>
            </div>
        </div>
    )
}

export default HistorialCama;